import { I18n } from '@editorjs/editorjs/types/api';
import ButtonDomFactory from '../../common/factory/button-dom-factory';
import DomFactory from '../../common/factory/factory';

export default class ActivitySelectorDomFactory extends DomFactory {
  private buttonFactory: ButtonDomFactory;

  constructor(i18n: I18n) {
    super(i18n);
    this.buttonFactory = new ButtonDomFactory(i18n);
  }

  public createWrapper() {
    const activitySelector = document.createElement('div');
    activitySelector.classList.add('activity-selector');
    return activitySelector;
  }

  public createButton({ text, svg }: { text: string; svg: string }) {
    return this.buttonFactory.createButton({ text, svg });
  }

  public createButtonText(text: string) {
    return this.buttonFactory.createButtonText(text);
  }

  public createButtonIcon(svg: string) {
    return this.buttonFactory.createButtonIcon(svg);
  }
}
